import { useInfiniteQuery } from "react-query"
import PerkService from "~services/PerkService"
import { filtersProps } from "~components/dashboard/RedemptionWidget"

const usePerkRedemptions = (filters: filtersProps) => {
  return useInfiniteQuery(
    ["perk-redemptions", filters],
    ({ pageParam = 0 }) =>
      PerkService.getPerkRedemptions(filters, {
        pageParam,
      }),
    {
      enabled: false,
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.hasNextPage
      },
    }
  )
}

export default usePerkRedemptions
